import { gql } from "@apollo/client";

export const GET_CASES_BY_ORGANIZATION_ID = gql`
  query GetAllCasesByOrgId($orgId: String!) {
    getAllCaseByOrgId(orgId: $orgId) {
      id
      caseNumber
      orgId
      status
      createdAt
      updatedAt
      referral {
        id
        from
        user {
          id
          firstName
          lastName
          avatarUrl
          email
          createdAt
          updatedAt
          verified
          # plan
        }
        userId
        eligibilityStatus
        serviceId
        serviceName
        orgId
        status
        isSelfReferral
      }
    }
  }
`;
